import { useTranslation } from 'react-i18next';
import { getCurrentLanguage } from '../utils.ts';

export function useCurrentLocale() {
  const { i18n } = useTranslation();
  return getCurrentLanguage(i18n);
}
